import { WebViewWindow } from '../../types';

declare let window: WebViewWindow;

export function postMessageFromWebView(message: string): void {
  window.ReactNativeWebView.postMessage(message);
}
